import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'cost-plan-submission',
  imports: [],
  templateUrl: './cost-plan-submission.component.html',
  styleUrl: './cost-plan-submission.component.less'
})
export class CostPlanSubmissionComponent {
   private router: Router = inject(Router);

    returnHomePage(): void {
        this.router.navigateByUrl('/');
    }
}
